import './nav.scss';
import React from 'react';
import { Layout } from 'antd';
import loadable from '@loadable/component';

const { Footer } = Layout;

const FooterBar: React.FunctionComponent = () => {
    const LanguageSwitcherComponent = loadable(() => import('../language-switcher/language-switcher'), {
        fallback: <React.Fragment />,
    });

    return (
        <Footer className="footer-container">
            <div className="nav">
                <LanguageSwitcherComponent />
            </div>
        </Footer>
    );
};

export default FooterBar;
